import React from 'react'
import { FaSpinner } from 'react-icons/fa'

const SpinnerComp = () => {
  return (
    <div className='w-full mx-auto flex justify-center'>
      <h1 className='animate-spin text-xl text-center'>
        <FaSpinner />
      </h1>
    </div>
  )
}

export default SpinnerComp
